<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useFunctionGetter } from 'dashboard/composables/store';

import WootReports from './components/WootReports.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const { t } = useI18n();
const route = useRoute();
const inbox = useFunctionGetter('inboxes/getInboxById', route.params.id);

const reportTitle = computed(
  () => inbox.value?.name || t('INBOX_REPORTS.HEADER')
);
</script>

<template>
  <WootReports
    v-if="inbox.id"
    :key="inbox.id"
    type="inbox"
    getter-key="inboxes/getInboxes"
    action-key="inboxes/get"
    header-icon="i-lucide-inbox"
    header-accent="cyan"
    back-route="inbox_reports_index"
    :selected-item="inbox"
    :download-button-label="$t('INBOX_REPORTS.DOWNLOAD_INBOX_REPORTS')"
    :report-title="reportTitle"
    :report-subtitle="$t('INBOX_REPORTS.DESCRIPTION')"
  />
  <div v-else class="w-full py-20">
    <Spinner class="mx-auto" />
  </div>
</template>
